import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)] h-full flex flex-col" }
const _hoisted_2 = { class: "py-6 mx-6" }
const _hoisted_3 = { class: "flex-1 px-6 pt-6 bg-primary-100" }
const _hoisted_4 = { class: "grid w-full grid-cols-5 gap-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col justify-between col-span-1 p-6 bg-white border rounded-lg"
}
const _hoisted_7 = { class: "mb-1 text-sm font-semibold text-neutral-900" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline-block shrink-0 text-primary-600",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.16667 2.54492C5.41671 2.95946 2.5 6.13869 2.5 9.99915C2.5 14.1413 5.85786 17.4991 10 17.4991C13.8605 17.4991 17.0397 14.5824 17.4542 10.8325H9.16667V2.54492Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.0732 7.49915H12.5V2.92606C14.631 3.67926 16.3199 5.36819 17.0732 7.49915Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col justify-between col-span-1 p-6 bg-white border rounded-lg"
}
const _hoisted_14 = { class: "mb-1 text-sm font-semibold text-neutral-900" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline-block shrink-0 text-primary-600",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.16667 2.54492C5.41671 2.95946 2.5 6.13869 2.5 9.99915C2.5 14.1413 5.85786 17.4991 10 17.4991C13.8605 17.4991 17.0397 14.5824 17.4542 10.8325H9.16667V2.54492Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.0732 7.49915H12.5V2.92606C14.631 3.67926 16.3199 5.36819 17.0732 7.49915Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 2,
  class: "flex flex-col justify-between col-span-1 p-6 bg-white border rounded-lg"
}
const _hoisted_20 = { class: "mb-1 text-sm font-semibold text-neutral-900" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "inline-block shrink-0 text-primary-600",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.16667 2.54492C5.41671 2.95946 2.5 6.13869 2.5 9.99915C2.5 14.1413 5.85786 17.4991 10 17.4991C13.8605 17.4991 17.0397 14.5824 17.4542 10.8325H9.16667V2.54492Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.0732 7.49915H12.5V2.92606C14.631 3.67926 16.3199 5.36819 17.0732 7.49915Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "text-sm text-gray-500" }
const _hoisted_24 = ["href"]

import { onMounted, ref } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue"; 
import { RoleTypes } from '../enums/RoleTypes';

interface sampleDataInfo {
    id: number
    label: string,
    description: string,
    link: string, 
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const userRole = ref();
onMounted(() => {
    userRole.value =  JSON.parse(localStorage.getItem('user'));  
})
 
const sampleData = ref<sampleDataInfo[]> ([
    {
        id: 10,
        label: 'Patient related report',
        description: 'View patient related reports',
        link: '/reports/patient-related-report', 
    },
    // {
    //     label: 'Comorbid Report',
    //     description: 'View VAC/VAW Report',
    //     link: '/reports/comorbid-report'
    // },
    // {
    //     label: 'Case Related Age Group Report',
    //     description: 'View case related age group reports',
    //     link: '/reports/case-related-age-group-report'
    // },
    {
        id: 20,
        label: 'Case related reports',
        description: 'View case related reports',
        link: '/reports/case-related-specific-age', 
    },
    {
        id: 30,
        label: 'Primary Diagnosis Related Reports',
        description: 'View primary diagnosis related reports',
        link: '/reports/primary-diagnosis-related', 
    },
    
    {
        id: 40,
        label: 'Intake form',
        description: 'View intake form reports',
        link: '/reports/intake-report', 
    },
    {
        id: 50,
        label: 'Safety assessment',
        description: 'View safety assessment reports',
        link: '/reports/safety-assessment-report', 
    },
    {
        id: 60,
        label: 'Intervention report by patient',
        description: 'View intervention records reports',
        link: '/reports/intervention-records-report', 
    },
    {
        id: 70,
        label: 'Intervention report by type',
        description: 'View intervention age group reports',
        link: '/reports/intervention-report', 
    },
    {
        id: 80,
        label: 'Court schedule report',
        description: 'View court schedule reports',
        link: '/reports/court-schedule-report', 
    },
    // {
    //     label: 'Caseload Report',
    //     description: 'View caseload reports',
    //     link: '/reports/caseload-report'
    // },
    {
        id: 90,
        label: 'Patient by personnel',
        description: 'View patient by personnel reports',
        link: '/reports/patient-personnel-report', 
    },
    {
        id: 100,
        label: 'Workload report by personnel',
        description: 'View workload reports',
        link: '/reports/workload-report', 
    },
    {
        id: 120,
        label: 'Office report',
        description: 'View office reports',
        link: '/reports/office-report', 
    },
    {
        id: 110,
        label: 'System logs',
        description: 'View system logs reports',
        link: '/reports/system-logs-report', 
    },
]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { mainCustomClass: "!pb-0" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Report Management",
            description: "View the report and data analytics in the system."
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sampleData.value, (item) => {
              return (_openBlock(), _createElementBlock("div", { key: item }, [
                (item.id == 11)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN || userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN_IT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("p", _hoisted_7, [
                              _createTextVNode(_toDisplayString(item.label) + " ", 1),
                              _hoisted_8
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("p", _hoisted_10, _toDisplayString(item.description), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("a", {
                                href: item.link,
                                class: "text-sm font-semibold transition text-primary-600 hover:text-primary-800"
                              }, "See Report", 8, _hoisted_11)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.id == 110)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN || userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN_IT || userRole.value?.role_id == _unref(RoleTypes).OFFICE_ADMIN)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("p", _hoisted_14, [
                              _createTextVNode(_toDisplayString(item.label) + " ", 1),
                              _hoisted_15
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(item.description), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("a", {
                                href: item.link,
                                class: "text-sm font-semibold transition text-primary-600 hover:text-primary-800"
                              }, "See Report", 8, _hoisted_18)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_20, [
                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                          _hoisted_21
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(item.description), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          href: item.link,
                          class: "text-sm font-semibold transition text-primary-600 hover:text-primary-800"
                        }, "See Report", 8, _hoisted_24)
                      ])
                    ]))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})